export default {
  GET_GOAL_TRACKING_QUERY: Symbol.for('GET_GOAL_TRACKING_QUERY'),
  SET_GOAL_TRACKING_COMMAND: Symbol.for('SET_GOAL_TRACKING_COMMAND'),
  GOAL_TRACKING_REPOSITORY: Symbol.for('GOAL_TRACKING_REPOSITORY'),
  GOAL_TRACKING_STATE_MANAGER: Symbol.for('GOAL_TRACKING_STATE_MANAGER'),
};
